"use client";

import { ServiceSliderSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import { renderGeneratedSection } from "./generated-section-renderer";
import { serviceSliderRenderers } from "./generated-sections-registry";

const GeneratedServiceSliderSection: FC<ServiceSliderSectionProps> = (
  props,
) => {
  return renderGeneratedSection(
    props,
    serviceSliderRenderers,
    "Home8",
    (x) => x.setting.Appearance?.Key,
  );
};

export default GeneratedServiceSliderSection;
